import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0a611afa&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=0a611afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a611afa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavSubordinateMenu: require('D:/Project/kpwebsite/PC/components/nav/subordinate-menu.vue').default})
